import { useTranslation } from "react-i18next";

import OperationsCanvas from "@/components/OperationsCanvas";
import SectionHeader from "@/components/SectionHeader";

export type OperationKind = "product" | "presence";

export type OperationService =
  | "productLead"
  | "fullstack"
  | "frontend"
  | "design"
  | "brand"
  | "website"
  | "googleBusiness";

export type Operation = {
  client: string;

  product?: string;
  kind: OperationKind;
  services: OperationService[];

  seats?: number;
  since?: string;
  stack?: string[];
  logo?: string;
};

export default function Operations({ operations }: { operations: Operation[] }) {
  const { t } = useTranslation();

  if (operations.length === 0) return null;

  return (
    <section
      className="relative w-full flex overflow-hidden"
      aria-label={t("operations.heading")}
    >
      <div className="page-shell relative flex flex-col gap-12 md:gap-16 px-4 md:px-8 xl:px-16 pt-20 md:pt-24 pb-12 md:pb-14">
        <SectionHeader
          eyebrow={t("operations.heading")}
          title={t("operations.title")}
          support={t("operations.support")}
        />

        <OperationsCanvas operations={operations} />
      </div>
    </section>
  );
}
